import React, { useContext } from 'react'
import { LanguageContext } from '../../container/Language';
import Background from '../../images/bg.jpg'
import profile from '../../images/profile.png'


const Profile = () => {
    const { dictionary } = useContext(LanguageContext);
    return (
        <div className="card-started" id="home-card">
            <div className="profile">
                <div className="slide" style={{ backgroundImage: `url('${Background}')` }}></div>
                <div className="image">
                    <img src={profile} alt="" />
                </div>
                <div className="title">Johan Mickaël</div>
                <div className='subtitle'>{dictionary.jobTitle.title}</div>
                <div className="subtitle subtitle-typed">
                    <div className="typing-title">
                        {
                            dictionary.jobTitle.item.map((item, i) => (<p key={`jobtitle-${i}`}>{item}</p>))
                        }
                    </div>
                </div>
                <div className="social">
                    <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/johan-mickael/"><span className="fa fa-linkedin"></span></a>
                    <a target="_blank" rel="noreferrer" href="https://github.com/johan-mickael"><span className="fa fa-github"></span></a>
                    <a target="_blank" rel="noreferrer" href="https://www.facebook.com/johan.mickael/"><span
                        className="fa fa-facebook"></span></a>
                    <a target="_blank" rel="noreferrer" href="mailto:m.johan.rkt@gmail.com"><span
                        className="fa fa-envelope"></span></a>
                        <a target="_blank" rel="noreferrer" href="tel:+33769348744"><span
                        className="fa fa-phone"></span></a>
                </div>
                <div className="lnks">

                    <a href="documents/resume.pdf" target="_blank" className="lnk">
                    <i class="fas fa-download"></i>
                        <span className="text"> {dictionary.jobTitle.resumeBtn}</span>
                    </a>
                    <a href="#" className="lnk discover">
                    <i class="fas fa-handshake"></i>
                        <span className="text"> {dictionary.jobTitle.contactBtn}</span>
                    </a>
                </div>

            </div>

        </div>
    )
}

export default Profile